import {
	Modal,
	MimaInput,
	MimaText,
	MimaButton,
	ReceiptCheckBox as RCB,
	PageLoader,
} from '../../components';
import styles from '../../assets/styles/Commission/Commission.module.scss';
import { Formik } from 'formik';
import { payrollStore } from '../../stores';
import React from 'react';

const CreateComType = ({
	closeModal,
	loading,
	validationSchema,
	onSubmit,
}) => {
	return (
		<Modal closeModal={closeModal}>
			<MimaText
				variant="subtitle"
				color="var(--color-primary)"
				align="center"
				mb={3}>
				Create Deduction Type
			</MimaText>
			<Formik
				initialValues={{
					name: '',
					value: '',
					type: '',
				}}
				validationSchema={validationSchema}
				onSubmit={onSubmit}>
				{({
					handleChange,
					handleBlur,
					handleSubmit,
					setFieldValue,
					values,
					errors,
					touched,
				}) => (
					<div>
						<MimaInput
							type="text"
							labelTitle="Name"
							placeholder="Name"
							name="name"
							value={values.name}
							onChange={handleChange}
							onBlur={handleBlur}
							error={errors.name}
							touched={touched.name}
						/>

						<MimaText variant="small" mt={2} ml={2}>
							Type
						</MimaText>
						<div className="modal__checks">
							<RCB
								title="FixedAmount"
								onChange={() => {
									setFieldValue('type', 'FixedAmount');
								}}
								checked={values.type === 'FixedAmount'}
								name="type"
							/>
							<RCB
								title="Rate"
								checked={values.type === 'Rate'}
								onChange={() => setFieldValue('type', 'Rate')}
								name="type"
							/>
						</div>
						{errors.type ? (
							<div className={styles.error}>
								{''}
								{touched.type && errors.type}
								{''}
							</div>
						) : null}

						<MimaInput
							type="number"
							labelTitle="Value"
							placeholder="Value"
							min={0}
							name="value"
							value={values.value}
							onChange={handleChange}
							onBlur={handleBlur}
							error={errors.value}
							touched={touched.value}
						/>
						<MimaButton
							title="Create Deduction"
							type="submit"
							loading={loading}
							onClick={handleSubmit}
							mt={2}
						/>
					</div>
				)}
			</Formik>
			<>
				{loading ? (
					<PageLoader
						title="While we fetch your employee Details"
						loading={loading}
					/>
				) : (
					<div className="whiteTable">
					<table>
						<thead>
							<tr>
								<th> Name </th>
								<th> Value </th>
								<th> Type </th>
							</tr>
						</thead>
						<tbody>
							{payrollStore?.deductions?.map((deduction, key) => (
								<tr key={key}>
									<td>{deduction.name}</td>
									<td>{deduction.value}</td>
									<td>{deduction.type}</td>
								</tr>
							))}
						</tbody>
					</table>
					</div>
				)}
			</>
		</Modal>
	);
};

export default CreateComType;
